var map = {
	"./Accordion.vue": 315,
	"./AdditionalOptions.vue": 937,
	"./BaseColors.vue": 481,
	"./BaseColorsModal.vue": 483,
	"./Blog.vue": 938,
	"./BreadCrumbs.vue": 179,
	"./Button.vue": 68,
	"./CardList.vue": 939,
	"./CardsInTwoColumns.vue": 940,
	"./CardsListWithIcon.vue": 941,
	"./Colors.vue": 942,
	"./Columns.vue": 943,
	"./ContactsMaps.vue": 944,
	"./ContactsTabs.vue": 945,
	"./ContactsText.vue": 946,
	"./CookieConsent.vue": 484,
	"./CustomComponent.vue": 947,
	"./DynamicHeader.vue": 948,
	"./ExpertiseAndArticles.vue": 949,
	"./Footer.vue": 950,
	"./Form.vue": 96,
	"./FormColorNotFound.vue": 316,
	"./GalleryWithText.vue": 951,
	"./Header.vue": 485,
	"./HeaderBlock.vue": 952,
	"./ImageAndText.vue": 953,
	"./ImageComponent.vue": 48,
	"./ImageOneBlock.vue": 954,
	"./ImagesCardsBlock.vue": 955,
	"./InlineSlider.vue": 118,
	"./InstagramPosts.vue": 956,
	"./MarginBlock.vue": 957,
	"./MaterialsAndColors.vue": 958,
	"./Modal.vue": 135,
	"./NotFoundBlock.vue": 959,
	"./OurWorksSlider.vue": 960,
	"./PricesColumn.vue": 961,
	"./Products.vue": 962,
	"./QuestionAnswer.vue": 963,
	"./RelatedSliders.vue": 489,
	"./ResultModal.vue": 318,
	"./ScrollToTopBtn.vue": 581,
	"./SimpleForm.vue": 964,
	"./SimpleSlider.vue": 965,
	"./SliderBlock.vue": 966,
	"./SliderExampleWork.vue": 967,
	"./SliderWrapper.vue": 102,
	"./TabsSlider.vue": 968,
	"./TabsWithBlocks.vue": 969,
	"./TabsWithImagesAndText.vue": 970,
	"./TabsWithOneImageAndText.vue": 971,
	"./TabsWithTable.vue": 972,
	"./TextBlock.vue": 973,
	"./TriggerBlock.vue": 974,
	"./TriggerBlockImages.vue": 975,
	"./TriggerBlockImagesBorder.vue": 976,
	"./TriggerBlockWithSixPicture.vue": 977,
	"./UsefulArticles.vue": 978,
	"./Video.vue": 979,
	"./WorksList.vue": 980,
	"./base/AppTab.vue": 136,
	"./base/AppTabs.vue": 482,
	"./base/BaseForm.vue": 317,
	"./base/BaseTabs.vue": 128,
	"./base/ColorsTabs.vue": 319,
	"./blog/BlogComponentWrapper.vue": 76,
	"./blog/BlogContentNav.vue": 981,
	"./blog/BlogFourPicturesWithText.vue": 982,
	"./blog/BlogHeader.vue": 983,
	"./blog/BlogMainText.vue": 984,
	"./blog/BlogPicsInColumns.vue": 985,
	"./blog/BlogQuotes.vue": 986,
	"./blog/BlogSlider.vue": 987,
	"./blog/BlogSocial.vue": 988,
	"./blog/BlogTableContents.vue": 989,
	"./blog/BlogThreeColumnsTable.vue": 990,
	"./blog/BlogTwoColumnsTableFirst.vue": 991,
	"./blog/BlogTwoColumnsTableSecond.vue": 992,
	"./blog/BlogVideo.vue": 993,
	"./blog/HeaderFullImage.vue": 994,
	"./blog/HeaderWithPic.vue": 995,
	"./blog/ImageWithText.vue": 996,
	"./blog/ParagraphWithHeadings.vue": 997,
	"./blog/PictureWithText.vue": 998,
	"./blog/SocialLinks.vue": 999,
	"./blog/Subscribe.vue": 1000,
	"./blog/TextFramed.vue": 1001,
	"./blog/additional/AdditionalText.vue": 1002,
	"./blog/additional/FeedbackFormSidebar.vue": 1003,
	"./blog/additional/PictureWithLink.vue": 1004,
	"./blog/additional/SimilarArticles.vue": 1005,
	"./colors/Color.vue": 232,
	"./footer/FooterSocial.vue": 488,
	"./menu/Menu.vue": 320,
	"./menu/MobileMenu.vue": 486,
	"./menu/MobileMenuSubmenuItem.vue": 487,
	"./menu/Submenu.vue": 321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1074;